import { resolveTransitionHooks } from 'vue'
import RequestService from '../services/request.service'

export const requestModule = {
  namespaced: true,

  state: {
    requests: [],
    criterias: null,
    requestID: null,
    requestDetail: null,
    updatedParams: null,
    requestParams: null,
    paramsDiff: null,
    invalidData: null
  },

  actions: {
    async list ({ commit }, criterias) {
      return RequestService.list(criterias).then(
        response => {
          const requests = response.data.requests.sort(function(a, b) {
            var c = new Date(a.requestDate);
            var d = new Date(b.requestDate);
            return d-c;
        });
          commit('listSuccess', requests)
          return Promise.resolve(requests)
        },
        error => {
          commit('searchFailure')
          return Promise.reject(error.response)
        }
      )
    },

    async detail ({ commit }, criterias) {
      return RequestService.detail(criterias).then(
        response => {
          const detail = response.data
          if (detail.requestProductDescription) {
            detail.requestProductDescription.splice(3, 1)
            detail.requestProductDescription.splice(4, 1)
            commit('requestSuccess', detail)
            return Promise.resolve(detail)
          }
          else {
            commit('detailReset')
            return Promise.reject(detail.responseCode)
          }
        },
        error => {
          commit('detailReset')
          return Promise.reject(error.response)
        }
      )
    },

    async cancel ({ commit }, criterias) {
      return RequestService.cancel(criterias).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async updatedParams ({ commit }, criterias) {
      return RequestService.updatedParams(criterias).then(
        response => {
          const updatedParams = response.data
          commit('updatedParamsSuccess', updatedParams)
          return Promise.resolve(updatedParams)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async paramsDiff ({ commit }, criterias) {
      return RequestService.paramsDiff(criterias).then(
        response => {
          const paramsDiff = response.data
          commit('paramsDiffSuccess', paramsDiff)
          return Promise.resolve(paramsDiff)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async requestParams ({ commit }, criterias) {
      return RequestService.requestParams(criterias).then(
        response => {
          const requestParams = response.data
          commit('requestParamsSuccess', requestParams)
          return Promise.resolve(requestParams)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async listReset ({ commit }) {
      commit('listReset')
    },

    async detailReset ({ commit }) {
      commit('detailReset')
    },

    async setCriterias ({ commit }, criterias) {
      commit('setCriterias', criterias)
    },

    async resetCriterias ({ commit }) {
      commit('resetCriterias')
    },

    async setRequestID ({ commit }, requestID) {
      commit('setRequestID', requestID)
    },

    async resetRequestID ({ commit }) {
      commit('resetRequestID')
    },

    async updatedParamsSuccess ({ commit }, updatedParams) {
      commit('updatedParamsSuccess', updatedParams)
    },

    async updatedParamsReset ({ commit }) {
      commit('updatedParamsReset')
    },

    async paramsDiffSuccess ({ commit }, paramsDiff) {
      commit('paramsDiffSuccess', paramsDiff)
    },

    async paramsDiffReset ({ commit }) {
      commit('paramsDiffReset')
    },

    async requestParamsSuccess ({ commit }, paramsDiff) {
      commit('requestParamsSuccess', paramsDiff)
    },

    async requestParamsReset ({ commit }) {
      commit('requestParamsReset')
    },

    async invalidData ({ commit }, error) {
      commit('invalidData', error)
    },

    async resetInvalidData ({ commit }) {
      commit('invalidData', null)
    }

  },

  mutations: {
    listSuccess (state, requests) {
      state.requests = requests
    },

    searchFailure (state) {
      state.requests = []
    },

    listReset (state) {
      state.requests = []
    },

    setCriterias (state, criterias) {
      state.criterias = criterias
    },

    resetCriterias (state) {
      state.criterias = null
    },

    requestSuccess (state, request) {
      state.requestDetail = request
    },

    detailReset (state) {
      state.requestDetail = null
    },

    updatedParamsSuccess (state, updatedParams) {
      state.updatedParams = updatedParams
    },

    updatedParamsReset (state) {
      state.updatedParams = null
    },

    paramsDiffSuccess (state, paramsDiff) {
      state.paramsDiff = paramsDiff
    },

    paramsDiffReset (state) {
      state.paramsDiff = null
    },

    requestParamsSuccess (state, requestParams) {
      state.requestParams = requestParams
    },

    requestParamsReset (state) {
      state.requestParams = null
    },

    setRequestID (state, requestID) {
      state.requestID = requestID
    },

    resetRequestID (state) {
      state.requestID = null
    },

    invalidData (state, error) {
      state.invalidData = error
    }
  }
}
